import {
  TypesActionsPrintingService,
  LIST_PRINTING_SERVICE,
  SHOW_PRINTING_SERVICE,
  UPDATE_PRINTING_SERVICE,
  CREATE_PRINTING_SERVICE,
  DELETE_PRINTING_SERVICE,
  RESET_PRINTING_SERVICE_STATE,
  PRINTING_SERVICE_LIST,
} from '../../../store/actions/printingService/PritingSeviceTypes';
import { PrintingServiceState } from 'src/store/models/printingService/PrintingServiceState';
import { printingServiceInitialState } from '../../../types/printingService/interfaces';
import { generalResponse } from '../../../types/common/interfaces';

const initialState: PrintingServiceState = {
  printingServices: generalResponse,
  printingService: printingServiceInitialState,
  printingServiceList: [],
};

export default function cashRegisterReducer(
  state = initialState,
  action: TypesActionsPrintingService
) {
  switch (action.type) {
    case LIST_PRINTING_SERVICE: {
      const printingServices = action.payload;
      return {
        ...state,
        printingServices,
      };
    }
    case SHOW_PRINTING_SERVICE: {
      const printingService = action.payload;
      return {
        ...state,
        printingService,
      };
    }
    case UPDATE_PRINTING_SERVICE: {
      const printingService = action.payload;
      const index = state.printingServices.docs.findIndex(
        (todo) => todo._id === printingService._id
      );
      const newArray = [...state.printingServices.docs]; //making a new array
      newArray[index] = action.payload; //changing value in the new array
      const { docs, ...rest } = state.printingServices;
      const printingServices = {
        docs: newArray,
        ...rest,
      };
      return {
        ...state,
        printingServices,
      };
    }
    case DELETE_PRINTING_SERVICE: {
      const id = action.payload;
      const newArray = state.printingServices.docs.filter(
        (todo) => todo._id !== id
      );
      const { docs, ...rest } = state.printingServices;
      const printingServices = {
        docs: newArray,
        ...rest,
      };
      return {
        ...state,
        printingServices,
      };
    }
    case RESET_PRINTING_SERVICE_STATE: {
      return initialState;
    }
    case CREATE_PRINTING_SERVICE: {
      const printingService = action.payload;
      const newArray = [...state.printingServices.docs, printingService];
      const { docs, ...rest } = state.printingServices;
      const printingServices = {
        docs: newArray,
        ...rest,
      };
      return {
        ...state,
        printingServices,
      };
    }
    case PRINTING_SERVICE_LIST: {
      const printingServiceList = action.payload;
      return {
        ...state,
        printingServiceList,
      };
    }
    default: {
      return state;
    }
  }
}
